export default {
    'home': {
        component: import('@/components/integrations/protokol/inbox/Home'),
        permissions: ['use']
    },
    'page': {
        component: import('@/views/integrations/protokol/inbox/Index'),
        permissions: ['use']
    }
}
